<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-row>
            <a-col :span="12">
              <a-form-item label="业务号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="采销全流程" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ data['project'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="contractType === 100">
              <a-form-item label="购销合同" :label-col="labelCol" :wrapper-col="wrapperCol">
                <span>
                  {{ data['contract_number'] }}
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="contractType === 200">
              <a-form-item label="普通合同" :label-col="labelCol" :wrapper-col="wrapperCol">
                <span>
                  {{ data['contract_number'] }}
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同类型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  allow-clear
                  v-decorator="[
                    'invoice_contract_type',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in invoiceContractTypeList">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                发票信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="开票主体" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :filter-option="false"
                  :not-found-content="invoiceIssuerCorporationFetching ? undefined : null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'invoice_issuer_corporation_id',
                    {
                      rules: [
                        { required: true, message: '必填项，请填写信息' },
                      ],
                    },
                  ]"
                  placeholder="请输入公司名称"
                  :default-active-first-option="false"
                  @search="this.invoiceIssuerCorporationSearch"
                >
                  <a-spin v-if="invoiceIssuerCorporationFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in invoiceIssuerCompanyList" :key="d.id" :value="d.id">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="发票类型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  allow-clear
                  v-decorator="[
                    'invoice_type',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in invoiceTypeList">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="发票名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['invoice_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="发票数量" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number style="width: 50%" v-decorator="['invoice_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="发票金额" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['invoice_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                收票信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="收票主体" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :filter-option="false"
                  :not-found-content="recipientCorporationFetching ? undefined : null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'recipient_corporation_id',
                    {
                      rules: [
                        { required: true, message: '必填项，请填写信息' },
                      ],
                    },
                  ]"
                  placeholder="请输入公司名称"
                  :default-active-first-option="false"
                  @search="this.recipientCorporationSearch"
                >
                  <a-spin v-if="recipientCorporationFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in recipientCompanyList" :key="d.id" :value="d.id">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="纳税人识别号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['taxpayer_identification_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="开户行" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['bank_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="账号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['bank_account', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="地址" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['address', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="电话" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['phone', {rules: [{required: false, message: '必填项，请填写信息'}, {max:20, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="false">
              <a-form-item label="税额" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="2" style="width: 50%" v-decorator="['total_tax', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="税额"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="false">
              <a-form-item label="发票方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'method',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.method">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备注" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-textarea :rows="1" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                审批信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="开启审批" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-switch v-decorator="['is_approval_needed', { valuePropName: 'checked' }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :offset="10" span="4">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="8">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import { fapiao_list, fapiao_update } from '@/api/trade_fapiao'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { corporation_list } from '@/api/trade_corporation'
import { client_list } from '@/api/trade_client'
const fields = ['business_no', 'invoice_contract_type', 'invoice_issuer_corporation_id', 'recipient_corporation_id', 'invoice_type', 'invoice_name', 'invoice_quantity',
  'invoice_amount', 'taxpayer_identification_number', 'address', 'phone', 'bank_name', 'bank_account', 'method', 'is_approval_needed', 'remark']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.invoiceIssuerCorporationSearch = debounce(this.handleInvoiceIssuerCorporationSearch, 800)
    this.recipientCorporationSearch = debounce(this.handleRecipientCorporationSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      method: this.$Dictionaries.trade_fapiao_method,
      data: {},
      loading: false,
      projectFetching: false,
      projectList: [],
      contractList: [],
      contractType: undefined,
      invoiceContractTypeList: this.$Dictionaries.trade_invoice_contract_type,
      invoiceIssuerCorporationFetching: false,
      invoiceIssuerCompanyList: [],
      recipientCorporationFetching: false,
      recipientCompanyList: [],
      invoiceTypeList: this.$Dictionaries.trade_invoice_type
    }
  },
  created () {
    fields.forEach(v => this.form.getFieldDecorator(v))
  },
  mounted () {
    this.loadFaPiaoData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadFaPiaoData () {
      this.loading = true
      fapiao_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.data.invoice_contract_type = '' + this.data.invoice_contract_type
            this.data.invoice_type = '' + this.data.invoice_type
            this.data.method = '' + this.data.method
            this.id = this.data.id
            this.contractType = Number(this.data.contract_type.split(',')[0])
            if (this.data.invoice_issuer_corporation_id === -1) {
              this.data.invoice_issuer_corporation_id = undefined
            }
            if (this.data.recipient_corporation_id === -1) {
              this.data.recipient_corporation_id = undefined
            }
            this.loadEditInfo(this.data)
            if (this.data.invoice_issuer_corporation_id) {
              this.handleCorporation({ id: this.data.invoice_issuer_corporation_id }, 1)
            }
            if (this.data.recipient_corporation_id) {
              // this.handleCorporation({ id: this.data.recipient_corporation_id }, 2)
              this.clientLoadList({ id: this.data.recipient_corporation_id })
            }
          }
        }).finally(() => {
        this.loading = false
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        form.setFieldsValue(formData)
      })
    },
    handleInvoiceIssuerCorporationSearch (value) {
      this.handleCorporation({ name: value }, 1)
    },
    handleRecipientCorporationSearch (value) {
      // this.handleCorporation({ name: value }, 2)
      this.clientLoadList({ name: value })
    },
    clientLoadList (parameter) {
      this.recipientCorporationFetching = true
      this.recipientCompanyList = []
      client_list(parameter).then((res) => {
        this.recipientCompanyList = res.data.entries || []
      }).finally(() => {
        this.recipientCorporationFetching = false
      })
    },
    handleCorporation (parameter, index) {
      if (index === 1) {
        this.invoiceIssuerCorporationFetching = true
      } else {
        this.recipientCorporationFetching = true
      }
      corporation_list(parameter).then((res) => {
        if (index === 1) {
          this.invoiceIssuerCompanyList = res.data.entries || []
        } else {
          this.recipientCompanyList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.invoiceIssuerCorporationFetching = false
        } else {
          this.recipientCorporationFetching = false
        }
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          fapiao_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
